import styled, { css } from "styled-components";
import styleguide from "../../theme";
import { TextAlign, ResponsiveValue } from "../../types/style-types";
import React from "react";

interface TextProps extends React.ComponentPropsWithoutRef<"p"> {
  children: React.ReactNode;
  align?: ResponsiveValue<TextAlign>;
  size?: "small" | "medium";
  weight?: "regular" | "bold";
  truncate?: boolean;
  "aria-hidden"?: boolean;
}

type StyledProps = Required<
  Pick<TextProps, "align" | "size" | "weight" | "truncate">
>;

const StyledText = styled.p<StyledProps>`
  font-size: ${props =>
    props.size === "small"
      ? styleguide.fontSizes[14]
      : styleguide.fontSizes[16]};
  font-weight: ${props => styleguide.fontWeights[props.weight]};
  line-height: 1.5;

  ${props =>
    props.truncate &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
    `}

  @media screen and (min-width: ${styleguide.breakpoints.tablet}) {
    font-size: ${props =>
      props.size === "small"
        ? styleguide.fontSizes[16]
        : styleguide.fontSizes[18]};
  }

  ${props => {
    if (typeof props.align === "string") {
      return `text-align: ${props.align}`;
    }

    return css`
      text-align: ${props.align.mobile};

      @media (min-width: ${styleguide.breakpoints.desktop}) {
        text-align: ${props.align.desktop};
      }
    `;
  }}
`;

export function Text({
  children,
  align = "left",
  size = "medium",
  weight = "regular",
  truncate = false,
  "aria-hidden": ariaHidden
}: TextProps) {
  return (
    <StyledText
      aria-hidden={ariaHidden}
      truncate={truncate}
      align={align}
      size={size}
      weight={weight}
    >
      {children}
    </StyledText>
  );
}

export default Text;
